<div style="width: 100%; display: flex; align-items: center; gap: 8px">
  <landmark-icon
    style="margin: 0.5rem"
    [icon]="landmark().icon"
    [color]="landmark().hexaColor"
    [validate]="landmark().state === 'V'"
    [kind]="landmark().kind" />

  <div class="card_content">
    <h1>{{ landmark().label }}</h1>
    <p>{{ landmark().address }}</p>
  </div>
</div>

@if (distanceData()?.distance) {
  <div class="card_content">
    <p style="text-align: center">
      {{ distanceData().prefix }} {{ distanceData().distance | imperial: 'distance' : 2 }}
    </p>
  </div>
}

@if (isDisplayDevices()) {
  <div class="card_content_devices">
    <p>{{ landmark().devices.length }}</p>
    <mat-icon [style.color]="'var(--icon-muted)'">directions_card</mat-icon>
  </div>
}
